import React, { useState } from "react";
import SubscriptionIcon from '../../icons/SubscriptionIcon.png';
import { BASE_PATH } from "../../constants/awsBaseUrl";
const toTry = [
  "out_003.png",
  "out_002.png",
  "out_001.png",
]


const Preview = ({ videoId, color, notAccessible }) => {

  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const [srcNumber, setSrcNumber] = useState(0);

  const refreshDate = `${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`
  const baseUrl = `${BASE_PATH}t/outputs/${videoId}/Default/Thumbnails/${toTry[srcNumber]}`
  const customThumbnail = `${BASE_PATH}/outputs/${videoId}/Default/Thumbnails/out_003.png`
  return (
    <div className="thumbnail">
      <img
        className="thumbnail-img"
        style={loaded ? { transitionDuration: ".25s" } : { display: "none", transitionDuration: ".25s" }}
        src={`${customThumbnail}?refresh=${refreshDate}`}
        onLoad={() => setLoaded(true) }
        onError={(e) => {
          e.target.src=`${baseUrl}?refresh=${refreshDate}`
          // if(srcNumber >= toTry.length) {
          //   setFailed(true)
          // } else {
          //   setSrcNumber(srcNumber + 1);
          // }
        }}
        alt="video thumbnail"
        loading='lazy'
      />
      {notAccessible &&  <img className="thumbnail-lock-icon" src={SubscriptionIcon} alt='subscription icon' loading='lazy' />}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          padding: "25%",
        }}
      >
        <i
          className="fas fa-spinner fa-2x "
          style={{ 
            color: this?.props?.color && this.props.color, 
            visibility: failed || loaded ? 'hidden' : ''
          }}
        ></i>
      </div>
    </div>
  );
  
}

export default Preview;
